/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Coinvestments_Lpdealoverviewcontent_Select4Inputs */

const en_coinvestments_lpdealoverviewcontent_select4 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Select4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Select {type}" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Select4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_select4 = /** @type {((inputs: Coinvestments_Lpdealoverviewcontent_Select4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Select4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_select4(inputs)
});
export { coinvestments_lpdealoverviewcontent_select4 as "coInvestments_lpDealOverviewContent_select" }